export default class ClienteEndereco {
  constructor(
    id_cliente = null,
    id_item = null,
    tipo = 'R',
    id_tipo_endereco = 1,
    logradouro = '',
    numero = '',
    complemento = '',
    ponto_referencia = '',
    bairro = '',
    uf ='',
    cidade = '',
    cep = '',
    titulo = 'RESIDENCIAL',
    versao_imp = 0
  ) {
    this.id_cliente = id_cliente;
    this.id_item = id_item;
    this.tipo = tipo;
    this.id_tipo_endereco = id_tipo_endereco;
    this.logradouro = logradouro;
    this.numero = numero;
    this.complemento = complemento;
    this.ponto_referencia = ponto_referencia;
    this.bairro = bairro;
    this.uf = uf;
    this.cidade = cidade;
    this.cep = cep;
    this.titulo = titulo;
    this.versao_imp = versao_imp;
  }
}